// extracted by mini-css-extract-plugin
export var brand = "_c0-9";
export var compact = "_c0-6";
export var extraSmall = "_c0-7";
export var icon = "_c0-0";
export var large = "_c0-4";
export var light = "_c0-1";
export var medium = "_c0-5";
export var outline = "_c0-b";
export var primaryDark = "_c0-a";
export var primaryLight = "_c0-8";
export var primaryModern = "_c0-c";
export var success = "_c0-2";
export var successSolid = "_c0-3";